import React, { useState } from 'react';
import styled from 'styled-components';

export interface WorkViewerShellProps {
  children: React.ReactNode;
  onDragEnter?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
}

const WorkViewerShell: React.FC<WorkViewerShellProps> = ({
  children,
  onDragEnter,
  onDragOver,
  onDrop,
}) => {
  const [isExtended, setIsExtended] = useState(false);

  return (
    <Outer $isExtended={isExtended}>
      <ToggleButton
        role="button"
        aria-label={isExtended ? 'Collapse' : 'Expand'}
        aria-expanded={isExtended}
        onClick={() => setIsExtended(!isExtended)}
      >
        {isExtended ? '<  >' : '<>'}
      </ToggleButton>
      <Shell
        onDragEnter={onDragEnter}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        {children}
      </Shell>
    </Outer>
  );
};

const Outer = styled.div<{ $isExtended: boolean }>`
  position: relative;
  width: ${({ $isExtended }) => ($isExtended ? 'calc(50vw * 1.2)' : '50vw')};
  max-width: ${({ $isExtended }) => ($isExtended ? '840px' : '700px')};
  height: 100%;
  flex-shrink: 0;
  transition: width 0.3s ease, max-width 0.3s ease;
`;

const ToggleButton = styled.div`
  position: absolute;
  left: 100%;
  top: calc(13vh);
  height: 24px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  white-space: nowrap;
  z-index: 2;
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  cursor: pointer;
`;

const Shell = styled.section`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-top: calc(13vh);
  padding-bottom: 40px;
`;

export default WorkViewerShell;
